// src/components/flex-editorial/editorial.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query EditorialQuery($contentIds: [String!], $context: ContextInput!, $uriContext: UriContextInput!, $pageType: String!, $contentPurpose: String!) {\n    travelContentEditorial(\n      contentIds: $contentIds\n      context: $context\n      pageType: $pageType\n      uriContext: $uriContext\n      contentPurpose: $contentPurpose\n    ) {\n      ... on EditorialContent {\n        id\n        title\n        subtitle\n        unformattedHtml\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    headingType\n    egdsElementId\n    text\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      target\n      resource {\n        value\n      }\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment TextComponentsFragment on EMRichTextComponents {\n    __typename\n    header {\n      __typename\n      ...EGDSHeadingFragment\n    }\n    subHeader {\n      __typename\n      ...EGDSHeadingFragment\n    }\n    description {\n      ... on EGDSSpannableText {\n        ...EGDSSpannableTextFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment ClickActionsFragment on EMClickAction {\n    action {\n      __typename\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      accessibility\n      target\n      useRelativePath\n    }\n    clickActionType {\n      __typename\n      ... on UIPrimaryButton {\n        disabled\n        primary\n      }\n      ... on UISecondaryButton {\n        disabled\n        primary\n      }\n      ... on UITertiaryButton {\n        disabled\n        primary\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment ImageFragment on Image {\n    description\n    src: url\n    aspectRatio\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EMImageFragment on EMImage {\n    url\n    description\n    sourceSet {\n      src: url\n      aspectRatio\n      size\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment VideoFragment on Video {\n    description\n    url {\n      value\n    }\n    thumbnailClickAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment MediaAssetsFragment on EMMediaComponents {\n    items {\n      id\n      mediaAssetType\n      media {\n        __typename\n        ... on EMImage {\n          ...EMImageFragment\n        }\n      }\n      altText\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EMExperienceCardComponentsFragment on EMExperienceCardComponents {\n    textComponents {\n      ...TextComponentsFragment\n    }\n    mediaAssets {\n      ...MediaAssetsFragment\n    }\n    clickActions {\n      ...ClickActionsFragment\n    }\n    contentMetadata {\n      contentId\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  query ExperienceCardQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput\n    $contentTopic: String!\n    $experienceType: String!\n    $preview: Boolean\n    $requestDate: String\n    $egPlatformURL: String\n  ) {\n    travelExperienceManagerContent(\n      context: $context\n      uriContext: $uriContext\n      contentTopic: $contentTopic\n      experienceType: $experienceType\n      preview: $preview\n      requestDate: $requestDate\n      egPlatformURL: $egPlatformURL\n    ) {\n      __typename\n      editorialComponent {\n        __typename\n        content {\n          ...EMExperienceCardComponentsFragment\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  query HeroImageQuery($context: ContextInput!, $uriContext: UriContextInput!, $contentTopic: String!, $experienceType: String!) {\n    travelExperienceManagerContent(context: $context, uriContext: $uriContext, contentTopic: $contentTopic, experienceType: $experienceType) {\n      editorialComponent {\n        content {\n          ... on EMMediaComponents {\n            items {\n              media {\n                ...EMImageFragment\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  query HeroBannerQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput\n    $contentTopic: String!\n    $experienceType: String!\n    $preview: Boolean\n    $requestDate: String\n    $egPlatformURL: String\n  ) {\n    travelExperienceManagerContent(\n      context: $context\n      uriContext: $uriContext\n      contentTopic: $contentTopic\n      experienceType: $experienceType\n      preview: $preview\n      requestDate: $requestDate\n      egPlatformURL: $egPlatformURL\n    ) {\n      editorialComponent {\n        content {\n          ... on EMRichTextMediaActions {\n            clickActions {\n              action {\n                __typename\n                analytics {\n                  linkName\n                  referrerId\n                }\n                resource {\n                  value\n                }\n                accessibility\n                target\n                useRelativePath\n              }\n              clickActionType {\n                __typename\n                ... on UIPrimaryButton {\n                  disabled\n                  primary\n                }\n              }\n              description\n            }\n            mediaAssets {\n              items {\n                id\n                mediaAssetType\n                media {\n                  __typename\n                  ... on EMImage {\n                    ...EMImageFragment\n                  }\n                }\n                altText\n              }\n            }\n            textComponents {\n              header {\n                ...EGDSHeadingFragment\n              }\n              subHeader {\n                ...EGDSHeadingFragment\n              }\n              description {\n                ...EGDSSpannableTextFragment\n              }\n            }\n            contentMetadata {\n              contentId\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment RichTextFragment on RichText {\n    value\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment TextClickActionsFragment on EMClickAction {\n    action {\n      __typename\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      accessibility\n      target\n      useRelativePath\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  query TextQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput\n    $contentTopic: String!\n    $experienceType: String!\n    $preview: Boolean\n    $requestDate: String\n    $egPlatformURL: String\n  ) {\n    travelExperienceManagerContent(\n      context: $context\n      uriContext: $uriContext\n      contentTopic: $contentTopic\n      experienceType: $experienceType\n      preview: $preview\n      requestDate: $requestDate\n      egPlatformURL: $egPlatformURL\n    ) {\n      editorialComponent {\n        content {\n          ... on EMRichTextMediaActions {\n            textComponents {\n              header {\n                ...EGDSHeadingFragment\n              }\n              subHeader {\n                ...EGDSHeadingFragment\n              }\n              description {\n                ...EGDSHeadingFragment\n                ...EGDSSpannableTextFragment\n                ...RichTextFragment\n              }\n            }\n            contentMetadata {\n              contentId\n            }\n            clickActions {\n              ...TextClickActionsFragment\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  query ImageQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput\n    $contentTopic: String!\n    $experienceType: String!\n    $preview: Boolean\n    $requestDate: String\n    $egPlatformURL: String\n  ) {\n    travelExperienceManagerContent(\n      context: $context\n      uriContext: $uriContext\n      contentTopic: $contentTopic\n      experienceType: $experienceType\n      preview: $preview\n      requestDate: $requestDate\n      egPlatformURL: $egPlatformURL\n    ) {\n      editorialComponent {\n        content {\n          ... on EMRichTextMediaActions {\n            mediaAssets {\n              items {\n                id\n                mediaAssetType\n                media {\n                  __typename\n                  ... on EMImage {\n                    ...EMImageFragment\n                  }\n                }\n                altText\n              }\n            }\n            textComponents {\n              description {\n                ...EGDSSpannableTextFragment\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var __Query = gql(_templateObject());
var Editorial = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var _data_travelContentEditorial;
    var travelExperienceContent = (_data_travelContentEditorial = data === null || data === void 0 ? void 0 : data.travelContentEditorial) !== null && _data_travelContentEditorial !== void 0 ? _data_travelContentEditorial : [];
    if (loading || error || travelExperienceContent.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, travelExperienceContent.map(function(item, index) {
        if ((item === null || item === void 0 ? void 0 : item.__typename) !== "EditorialContent") {
            return null;
        }
        return /* @__PURE__ */ React.createElement("div", {
            key: index
        }, /* @__PURE__ */ React.createElement(UitkHeading, {
            tag: "h2",
            size: 5
        }, item.title), /* @__PURE__ */ React.createElement(UitkSubheading, {
            tag: "h3"
        }, item.subtitle), /* @__PURE__ */ React.createElement(UitkUnformattedHtml, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
            padding: {
                block: "three"
            }
        }, /* @__PURE__ */ React.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: item.unformattedHtml || ""
            }
        }))));
    }));
};
Editorial.displayName = "sharedui-Editorial";
// src/components/experience-card/experience-card.tsx
import React20 from "react";
import { gql as gql17, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/experience-card/__private/em-experience-card-components.tsx
import React19 from "react";
import { gql as gql16 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// src/components/experience-card/__private/__fragments/text-components.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var fragment = gql2(_templateObject1());
var _obj;
var EGDSHeadingStyleMap = (_obj = {}, _define_property(_obj, "H1" /* H1 */ , "h1"), _define_property(_obj, "H2" /* H2 */ , "h2"), _define_property(_obj, "H3" /* H3 */ , "h3"), _define_property(_obj, "H4" /* H4 */ , "h4"), _define_property(_obj, "H5" /* H5 */ , "h5"), _define_property(_obj, "H6" /* H6 */ , "h6"), _define_property(_obj, "H7" /* H7 */ , "h6"), _define_property(_obj, "H8" /* H8 */ , "h6"), _obj);
var _obj1;
var EGDSHeadingSizeMap = (_obj1 = {}, _define_property(_obj1, "H1" /* H1 */ , 2), _define_property(_obj1, "H2" /* H2 */ , 4), _define_property(_obj1, "H3" /* H3 */ , 5), _define_property(_obj1, "H4" /* H4 */ , 6), _define_property(_obj1, "H5" /* H5 */ , 7), _define_property(_obj1, "H6" /* H6 */ , 8), _define_property(_obj1, "H7" /* H7 */ , 8), _define_property(_obj1, "H8" /* H8 */ , 8), _obj1);
var EGDSHeading = function(param) {
    var data = param.data, size = param.size;
    var tag = data.headingType !== null ? EGDSHeadingStyleMap[data.headingType] : void 0;
    var headingSize = (size !== null && size !== void 0 ? size : data.headingType == null) ? void 0 : EGDSHeadingSizeMap[data.headingType];
    var elementId = data.egdsElementId !== null ? data.egdsElementId : void 0;
    return /* @__PURE__ */ React2.createElement(UitkHeading2, {
        tag: tag,
        size: headingSize,
        id: elementId
    }, data.text);
};
EGDSHeading.fragment = fragment;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment2 = gql3(_templateObject2());
var _obj2;
var EGDSParagraphSizeMap = (_obj2 = {}, _define_property(_obj2, "P1" /* P1 */ , 1), _define_property(_obj2, "P2" /* P2 */ , 2), _define_property(_obj2, "P3" /* P3 */ , 3), _obj2);
var EGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkParagraph, {
        size: EGDSParagraphSizeMap[data.style]
    }, data.text);
};
EGDSParagraph.fragment = fragment2;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment3 = gql4(_templateObject3());
var EGDSPlainText = function(param) {
    var data = param.data, align = param.align, weight = param.weight, size = param.size, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme;
    return /* @__PURE__ */ React4.createElement(UitkText, {
        whiteSpace: "pre-line",
        inline: true,
        align: align,
        weight: weight,
        size: size,
        theme: theme
    }, data.text);
};
EGDSPlainText.fragment = fragment3;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLink } from "uitk-react-link";
var fragment4 = gql5(_templateObject4());
var EGDSInlineLink = function(param) {
    var data = param.data, inline = param.inline, linkSize = param.linkSize, _param_target = param.target, target = _param_target === void 0 ? "_self" : _param_target;
    return /* @__PURE__ */ React5.createElement(UitkLink, {
        size: linkSize,
        inline: inline
    }, /* @__PURE__ */ React5.createElement("a", {
        href: data.action.resource.value,
        target: target,
        rel: "noopener noreferrer"
    }, data.text));
};
EGDSInlineLink.fragment = fragment4;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment5 = gql6(_templateObject5());
var _obj3;
var UitkTextWeightMap = Object.freeze((_obj3 = {}, _define_property(_obj3, "BOLD" /* BOLD */ , "bold"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "REGULAR" /* REGULAR */ , "regular"), _obj3));
var EGDSStylizedText = function(param) {
    var data = param.data, inline = param.inline, size = param.size, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme;
    return /* @__PURE__ */ React6.createElement(UitkText2, {
        weight: data.weight ? UitkTextWeightMap[data.weight] : void 0,
        inline: inline,
        size: size,
        theme: theme
    }, data.text);
};
EGDSStylizedText.fragment = fragment5;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment6 = gql7(_templateObject6(), EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSInlineLink.fragment);
var EGDSSpannableTextContent = function(param) {
    var data = param.data, align = param.align, weight = param.weight, linkSize = param.linkSize, textSize = param.textSize, target = param.target, theme = param.theme;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React7.createElement(EGDSPlainText, {
                data: data,
                weight: weight,
                size: textSize,
                align: align,
                theme: theme
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React7.createElement(EGDSStylizedText, {
                data: data,
                inline: true,
                size: textSize,
                theme: theme
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React7.createElement(EGDSInlineLink, {
                data: data,
                inline: true,
                linkSize: linkSize,
                target: target
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment6;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment7 = gql8(_templateObject7(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(param) {
    var data = param.data, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize, target = param.target, theme = param.theme;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, data.contents.map(function(content, index) {
        return /* @__PURE__ */ React8.createElement(EGDSSpannableTextContent, {
            data: content,
            key: index,
            weight: weight,
            textSize: textSize,
            linkSize: linkSize,
            target: target,
            theme: theme
        });
    }));
};
EGDSSpannableText.fragment = fragment7;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment8 = gql9(_templateObject8(), EGDSParagraph.fragment, EGDSPlainText.fragment, EGDSHeading.fragment, EGDSSpannableText.fragment);
var EGDSText = function(param) {
    var data = param.data, align = param.align, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize, target = param.target;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React9.createElement(EGDSHeading, {
                data: data
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React9.createElement(EGDSParagraph, {
                data: data
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React9.createElement(EGDSPlainText, {
                data: data,
                size: textSize,
                align: align
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React9.createElement(EGDSSpannableText, {
                data: data,
                linkSize: linkSize,
                textSize: textSize,
                weight: weight,
                target: target
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment8;
EGDSText.displayName = "EGDSText";
// src/components/experience-card/__private/__fragments/text-components.tsx
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
var fragment9 = gql10(_templateObject9(), EGDSHeading.fragment, EGDSSpannableText.fragment);
var Description = function(param) {
    var description = param.description;
    if ((description === null || description === void 0 ? void 0 : description.length) === 0) {
        return null;
    }
    return /* @__PURE__ */ React10.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two"
        }
    }, description.map(function(block, index) {
        return block.__typename === "EGDSSpannableText" && /* @__PURE__ */ React10.createElement(UitkSpacing2, {
            padding: {
                blockend: "two"
            },
            key: index
        }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(EGDSSpannableText, {
            data: block,
            key: index
        })));
    }));
};
var TextComponents = function(param) {
    var data = param.data, view = param.view;
    var header = data.header, subHeader = data.subHeader, description = data.description;
    switch(view){
        case "OnCanvas":
        case "Default":
            return /* @__PURE__ */ React10.createElement(React10.Fragment, null, header && /* @__PURE__ */ React10.createElement(UitkHeading3, {
                size: 6,
                tag: "h2"
            }, header.text), subHeader && /* @__PURE__ */ React10.createElement(UitkSpacing2, {
                margin: {
                    block: "two"
                }
            }, /* @__PURE__ */ React10.createElement(UitkHeading3, {
                size: 8
            }, subHeader.text)), /* @__PURE__ */ React10.createElement(Description, {
                description: description
            }));
        case "Eyebrow":
            var _data_subHeader, _data_header;
            return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkHeading3, {
                tag: "h6",
                size: 8
            }, (_data_subHeader = data.subHeader) === null || _data_subHeader === void 0 ? void 0 : _data_subHeader.text.toUpperCase()), /* @__PURE__ */ React10.createElement(UitkSpacing2, {
                padding: {
                    blockstart: "two"
                }
            }, /* @__PURE__ */ React10.createElement(UitkHeading3, {
                tag: "h6"
            }, (_data_header = data.header) === null || _data_header === void 0 ? void 0 : _data_header.text)), /* @__PURE__ */ React10.createElement(Description, {
                description: description
            }));
        default:
            return null;
    }
};
TextComponents.displayName = "TextComponents";
TextComponents.fragment = fragment9;
// src/components/event-config.ts
var event_experienceCard_presented = {
    event_name: "experience_card.presented",
    event_type: "Impression",
    event_version: "1.2.0",
    event_category: "Landing"
};
var event_experienceCard_selected = {
    event_name: "experience_card.selected",
    event_type: "Interaction",
    event_version: "1.2.0",
    event_category: "Landing"
};
var event_hero_presented = {
    event_name: "hero_banner.presented",
    event_type: "Impression",
    event_version: "1.2.0",
    event_category: "Landing"
};
var event_hero_selected = {
    event_name: "hero_banner.selected",
    event_type: "Interaction",
    event_version: "1.2.0",
    event_category: "Landing"
};
// src/components/util.ts
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var createContentDataPayload = function(analyticsJson, contentId) {
    var _analyticsJson_additional_context_user_interface, _analyticsJson_additional_context, _analyticsJson_additional_context_user_interface_component_id, _analyticsJson_additional_context_user_interface1, _analyticsJson_additional_context1, _analyticsJson_additional_context_user_interface2, _analyticsJson_additional_context2, _analyticsJson_additional_context_user_interface3, _analyticsJson_additional_context3, _analyticsJson_additional_context_user_interface4, _analyticsJson_additional_context4, _analyticsJson_device_information_device_type, _analyticsJson_device_information, _analyticsJson_device_information_device_type1, _analyticsJson_device_information1, _analyticsJson_user, _analyticsJson_user_authentication_state, _analyticsJson_user1;
    return {
        additional_context: {
            user_interface: {
                component_element_text: (_analyticsJson_additional_context = analyticsJson.additional_context) === null || _analyticsJson_additional_context === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface = _analyticsJson_additional_context.user_interface) === null || _analyticsJson_additional_context_user_interface === void 0 ? void 0 : _analyticsJson_additional_context_user_interface.component_element_text,
                component_id: ((_analyticsJson_additional_context1 = analyticsJson.additional_context) === null || _analyticsJson_additional_context1 === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface1 = _analyticsJson_additional_context1.user_interface) === null || _analyticsJson_additional_context_user_interface1 === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface_component_id = _analyticsJson_additional_context_user_interface1.component_id) === null || _analyticsJson_additional_context_user_interface_component_id === void 0 ? void 0 : _analyticsJson_additional_context_user_interface_component_id.toString()) || null,
                component_name: (_analyticsJson_additional_context2 = analyticsJson.additional_context) === null || _analyticsJson_additional_context2 === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface2 = _analyticsJson_additional_context2.user_interface) === null || _analyticsJson_additional_context_user_interface2 === void 0 ? void 0 : _analyticsJson_additional_context_user_interface2.component_name,
                component_position: ((_analyticsJson_additional_context3 = analyticsJson.additional_context) === null || _analyticsJson_additional_context3 === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface3 = _analyticsJson_additional_context3.user_interface) === null || _analyticsJson_additional_context_user_interface3 === void 0 ? void 0 : _analyticsJson_additional_context_user_interface3.component_position) ? parseInt((_analyticsJson_additional_context4 = analyticsJson.additional_context) === null || _analyticsJson_additional_context4 === void 0 ? void 0 : (_analyticsJson_additional_context_user_interface4 = _analyticsJson_additional_context4.user_interface) === null || _analyticsJson_additional_context_user_interface4 === void 0 ? void 0 : _analyticsJson_additional_context_user_interface4.component_position, 10) : null,
                content_id: contentId || null
            }
        },
        device_information: {
            device_type: ((_analyticsJson_device_information = analyticsJson.device_information) === null || _analyticsJson_device_information === void 0 ? void 0 : (_analyticsJson_device_information_device_type = _analyticsJson_device_information.device_type) === null || _analyticsJson_device_information_device_type === void 0 ? void 0 : _analyticsJson_device_information_device_type.toLowerCase()) ? capitalizeFirstLetter((_analyticsJson_device_information1 = analyticsJson.device_information) === null || _analyticsJson_device_information1 === void 0 ? void 0 : (_analyticsJson_device_information_device_type1 = _analyticsJson_device_information1.device_type) === null || _analyticsJson_device_information_device_type1 === void 0 ? void 0 : _analyticsJson_device_information_device_type1.toLowerCase()) : null
        },
        point_of_sale: analyticsJson.point_of_sale,
        user: {
            authentication_state: (analyticsJson === null || analyticsJson === void 0 ? void 0 : (_analyticsJson_user = analyticsJson.user) === null || _analyticsJson_user === void 0 ? void 0 : _analyticsJson_user.authentication_state) ? capitalizeFirstLetter(analyticsJson === null || analyticsJson === void 0 ? void 0 : (_analyticsJson_user1 = analyticsJson.user) === null || _analyticsJson_user1 === void 0 ? void 0 : (_analyticsJson_user_authentication_state = _analyticsJson_user1.authentication_state) === null || _analyticsJson_user_authentication_state === void 0 ? void 0 : _analyticsJson_user_authentication_state.toLowerCase()) : null
        }
    };
};
var _obj4;
var UILinkTargetMap = (_obj4 = {}, _define_property(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// src/components/experience-card/__private/__fragments/click-actions-component.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
var fragment10 = gql11(_templateObject10());
var ButtonTypeMap = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton
};
var ClickActions = function(props) {
    var _data_action;
    var data = props.data, view = props.view, experienceCardData = props.experienceCardData;
    var clickTracker = useEgClickstream();
    var onClickCapture = React11.useCallback(function() {
        if (experienceCardData) {
            var defaultImpressionData = _object_spread({
                event: event_experienceCard_selected
            }, experienceCardData);
            clickTracker(defaultImpressionData);
        }
    }, [
        clickTracker,
        experienceCardData
    ]);
    if (!((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.resource)) {
        return null;
    }
    switch(view){
        case "Eyebrow" /* Eyebrow */ :
            {
                var _data_action1;
                return /* @__PURE__ */ React11.createElement(UitkCardLink, null, /* @__PURE__ */ React11.createElement("a", {
                    href: data.action.resource.value,
                    target: ((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : _data_action1.target) ? UILinkTargetMap[data.action.target] : void 0,
                    onClick: onClickCapture
                }, data.action.accessibility));
            }
        case "Default" /* Default */ :
        case "OnCanvas" /* OnCanvas */ :
            {
                var Button = ButtonTypeMap[data.clickActionType.__typename];
                if (Button) {
                    return /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React11.createElement("a", {
                        href: data.action.resource.value,
                        target: data.action.target,
                        onClick: onClickCapture
                    }, /* @__PURE__ */ React11.createElement(Button, {
                        size: UitkButtonSize.SMALL
                    }, data.action.analytics.linkName)));
                }
                return /* @__PURE__ */ React11.createElement(UitkCardLink, null, /* @__PURE__ */ React11.createElement("a", {
                    href: data.action.resource.value,
                    target: data.action.target,
                    onClick: onClickCapture
                }, data.action.accessibility));
            }
    }
};
ClickActions.fragment = fragment10;
ClickActions.displayName = "ClickActions";
// src/components/experience-card/__private/__fragments/media-assets.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/media/image.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/components/media/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj5;
var aspectRatioMapper = (_obj5 = {}, _define_property(_obj5, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj5, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _define_property(_obj5, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj5, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj5, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj5, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj5, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj5, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj5);
// ../internal/src/components/media/image.tsx
var fragment11 = gql12(_templateObject11());
var Image = function(param) {
    var _param_data = param.data, description = _param_data.description, src = _param_data.src, aspectRatio = _param_data.aspectRatio;
    return /* @__PURE__ */ React12.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React12.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: src
    }));
};
Image.fragment = fragment11;
Image.displayName = "Image";
// ../internal/src/components/media/em-image.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkFigure as UitkFigure2, UitkImage as UitkImage2 } from "uitk-react-images";
// ../internal/src/components/media/utils/image-selector.ts
var imageSelector = function(sourceSet, aspectRatio, size) {
    var _sourceSet_find;
    return sourceSet === null || sourceSet === void 0 ? void 0 : (_sourceSet_find = sourceSet.find(function(source) {
        return source.aspectRatio === aspectRatio && source.size === size;
    })) === null || _sourceSet_find === void 0 ? void 0 : _sourceSet_find.src;
};
// ../internal/src/components/media/em-image.tsx
var fragment12 = gql13(_templateObject12());
var EMImage = function(param) {
    var data = param.data, aspectRatio = param.aspectRatio, imageSize = param.imageSize, className = param.className, imageFit = param.imageFit, placeholderImage = param.placeholderImage, roundcorner = param.roundcorner, imgRef = param.imgRef, lazyLoading = param.lazyLoading, blankDefault = param.blankDefault;
    var imageUrl = imageSelector(data.sourceSet, aspectRatio, imageSize);
    return /* @__PURE__ */ React13.createElement(UitkFigure2, {
        className: className,
        ratio: aspectRatioMapper[aspectRatio],
        imageFit: imageFit,
        roundcorner: roundcorner
    }, /* @__PURE__ */ React13.createElement(UitkImage2, {
        src: imageUrl,
        alt: data.description,
        lazyLoading: lazyLoading !== null && lazyLoading !== void 0 ? lazyLoading : "lazy",
        imgRef: imgRef,
        placeholderImage: placeholderImage,
        blankDefault: blankDefault
    }));
};
EMImage.fragment = fragment12;
EMImage.displayName = "EMImage";
// ../internal/src/components/media/video.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure as UitkFigure3 } from "uitk-react-images";
import { UitkVideo } from "uitk-react-video";
var fragment13 = gql14(_templateObject13());
var Video = function(param) {
    var _param_data = param.data, description = _param_data.description, url = _param_data.url, thumbnailClickAnalytics = _param_data.thumbnailClickAnalytics;
    var trackClick = useClickTracker();
    var _thumbnailClickAnalytics_referrerId, _thumbnailClickAnalytics_linkName;
    var analytics = {
        id: (_thumbnailClickAnalytics_referrerId = thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId) !== null && _thumbnailClickAnalytics_referrerId !== void 0 ? _thumbnailClickAnalytics_referrerId : "",
        description: (_thumbnailClickAnalytics_linkName = thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName) !== null && _thumbnailClickAnalytics_linkName !== void 0 ? _thumbnailClickAnalytics_linkName : "",
        callback: function(referrerId, linkName) {
            trackClick(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React14.createElement(UitkFigure3, null, /* @__PURE__ */ React14.createElement(UitkVideo, {
        analytics: analytics,
        alt: description,
        src: url.value
    }));
};
Video.fragment = fragment13;
Video.displayName = "Video";
// src/components/experience-card/__private/__fragments/media-assets.tsx
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var fragment14 = gql15(_templateObject14(), EMImage.fragment);
var MediaAssets = function(param) {
    var data = param.data, view = param.view;
    var items = data.items;
    var item = items === null || items === void 0 ? void 0 : items.at(0);
    if (!item || item.media.__typename !== "EMImage") {
        return null;
    }
    var media = item.media;
    switch(view){
        case "Eyebrow" /* Eyebrow */ :
            return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
                padding: {
                    blockend: "two"
                }
            }, /* @__PURE__ */ React15.createElement(EMImage, {
                data: media,
                className: "uitk-card-roundcorner-all",
                aspectRatio: "SIXTEEN_NINE" /* SIXTEEN_NINE */ ,
                imageSize: "S" /* S */ ,
                roundcorner: true,
                placeholderImage: true
            }));
        case "OnCanvas" /* OnCanvas */ :
            return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
                padding: {
                    blockend: "two"
                }
            }, /* @__PURE__ */ React15.createElement(EMImage, {
                data: media,
                className: "uitk-card-roundcorner-all",
                aspectRatio: "THREE_TWO" /* THREE_TWO */ ,
                imageSize: "S" /* S */ ,
                roundcorner: true,
                placeholderImage: true
            }));
        case "Default" /* Default */ :
            return /* @__PURE__ */ React15.createElement(EMImage, {
                data: media,
                aspectRatio: "SIXTEEN_NINE" /* SIXTEEN_NINE */ ,
                imageSize: "S" /* S */ ,
                placeholderImage: true
            });
    }
};
MediaAssets.fragment = fragment14;
MediaAssets.displayName = "MediaAssets";
// src/components/experience-card/__private/views/default-view-experience-card.tsx
import React16 from "react";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
var DefaultExperienceCard = function(param) {
    var textComponents = param.textComponents, mediaAssets = param.mediaAssets, clickActions = param.clickActions;
    return /* @__PURE__ */ React16.createElement(UitkCard, {
        border: true
    }, mediaAssets, /* @__PURE__ */ React16.createElement(UitkCardContentSection, null, textComponents, /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkLayoutFlex, {
        space: "two",
        direction: "row"
    }, clickActions))));
};
DefaultExperienceCard.displayName = "DefaultExperienceCard";
// src/components/experience-card/__private/views/eyebrow-view-experience-card.tsx
import React17 from "react";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
var EyebrowExperienceCard = function(param) {
    var textComponents = param.textComponents, mediaAssets = param.mediaAssets, clickActions = param.clickActions;
    return /* @__PURE__ */ React17.createElement(UitkCard2, null, mediaAssets, /* @__PURE__ */ React17.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend"
        ]
    }, textComponents, clickActions));
};
EyebrowExperienceCard.displayName = "DefaultExperienceCard";
// src/components/experience-card/__private/views/on-canvas-experience-card.tsx
import React18 from "react";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
var OnCanvasExperienceCard = function(param) {
    var textComponents = param.textComponents, mediaAssets = param.mediaAssets, clickActions = param.clickActions;
    return /* @__PURE__ */ React18.createElement(UitkCard3, null, mediaAssets, /* @__PURE__ */ React18.createElement(UitkCardContentSection3, {
        padded: [
            "blockstart",
            "blockend"
        ]
    }, textComponents, /* @__PURE__ */ React18.createElement(UitkSpacing5, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex2, {
        space: "two",
        direction: "row"
    }, clickActions))));
};
OnCanvasExperienceCard.displayName = "DefaultExperienceCard";
// src/components/experience-card/__private/experience-card-views.ts
var ExperienceCardViewMap = {
    Eyebrow: EyebrowExperienceCard,
    Default: DefaultExperienceCard,
    OnCanvas: OnCanvasExperienceCard
};
// src/components/experience-card/__private/em-experience-card-components.tsx
var fragment15 = gql16(_templateObject15(), TextComponents.fragment, MediaAssets.fragment, ClickActions.fragment);
var EMExperienceCardComponents = function(param) {
    var data = param.data, view = param.view, analyticsData = param.analyticsData;
    var textComponents = data.textComponents, mediaAssets = data.mediaAssets, clickActions = data.clickActions, contentMetadata = data.contentMetadata;
    var track = useEgClickstream2();
    var experienceCardData = analyticsData ? createContentDataPayload(JSON.parse(analyticsData), contentMetadata === null || contentMetadata === void 0 ? void 0 : contentMetadata.contentId) : null;
    if (experienceCardData) {
        var defaultImpressionData = _object_spread({
            event: event_experienceCard_presented
        }, experienceCardData);
        track(defaultImpressionData);
    }
    var EMExperienceCardComponent = ExperienceCardViewMap[view];
    var clickActionComponents = clickActions === null || clickActions === void 0 ? void 0 : clickActions.map(function(clickAction, index) {
        return /* @__PURE__ */ React19.createElement(ClickActions, {
            key: index,
            view: view,
            data: clickAction,
            experienceCardData: experienceCardData
        });
    });
    return /* @__PURE__ */ React19.createElement(EMExperienceCardComponent, {
        textComponents: textComponents && /* @__PURE__ */ React19.createElement(TextComponents, {
            view: view,
            data: textComponents
        }),
        mediaAssets: mediaAssets && /* @__PURE__ */ React19.createElement(MediaAssets, {
            view: view,
            data: mediaAssets
        }),
        clickActions: clickActionComponents
    });
};
EMExperienceCardComponents.fragment = fragment15;
EMExperienceCardComponents.displayName = "EMExperienceCardComponents";
// src/components/experience-card/experience-card.tsx
var __Query2 = gql17(_templateObject16(), EMExperienceCardComponents.fragment);
var ExperienceCard = function(props) {
    var _data_travelExperienceManagerContent_editorialComponent;
    var inputs = props.inputs, skipSsr = props.skipSsr, view = props.view, analyticsData = props.analyticsData;
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading || error || (data === null || data === void 0 ? void 0 : (_data_travelExperienceManagerContent_editorialComponent = data.travelExperienceManagerContent.editorialComponent) === null || _data_travelExperienceManagerContent_editorialComponent === void 0 ? void 0 : _data_travelExperienceManagerContent_editorialComponent.content.__typename) !== "EMExperienceCardComponents" || !data.travelExperienceManagerContent.editorialComponent.content.mediaAssets) {
        return null;
    }
    return /* @__PURE__ */ React20.createElement(EMExperienceCardComponents, {
        data: data.travelExperienceManagerContent.editorialComponent.content,
        view: view,
        analyticsData: analyticsData
    });
};
ExperienceCard.displayName = "sharedui-ExperienceCard";
// src/components/hero-image/hero-image.tsx
import React21 from "react";
import { gql as gql18, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType3, UitkImage as UitkImage3 } from "uitk-react-images";
var __Query3 = gql18(_templateObject17(), EMImage.fragment);
var HeroImage = function(props) {
    var _content_items_;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi3().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    if (loading) {
        return /* @__PURE__ */ React21.createElement(UitkFigure4, {
            ratio: UitkFigureAspectRatioType3.R16_9
        }, /* @__PURE__ */ React21.createElement(UitkImage3, {
            placeholderImage: true
        }));
    }
    if (error || !(data === null || data === void 0 ? void 0 : data.travelExperienceManagerContent.editorialComponent) || !data.travelExperienceManagerContent.editorialComponent.content) {
        return null;
    }
    var editorialComponent = data.travelExperienceManagerContent.editorialComponent;
    var content = editorialComponent.content;
    if (content.__typename !== "EMMediaComponents" || !content.items || content.items.length !== 1 || ((_content_items_ = content.items[0]) === null || _content_items_ === void 0 ? void 0 : _content_items_.media.__typename) !== "EMImage") {
        return null;
    }
    var media = content.items[0].media;
    return /* @__PURE__ */ React21.createElement(EMImage, {
        data: media,
        aspectRatio: "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ,
        imageSize: "XL" /* XL */ ,
        placeholderImage: true
    });
};
HeroImage.displayName = "sharedui-HeroImage";
// src/components/hero-banner/hero-banner.tsx
import React29 from "react";
import { gql as gql19, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2, useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useMultiArmBanditContext } from "@shared-ui/retail-travel-content-experience-orchestration";
// src/components/hero-banner/views/default-hero-banner.tsx
import React24 from "react";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard4 } from "uitk-react-cards";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkSubheading as UitkSubheading2 } from "uitk-react-text";
// src/components/hero-banner/views/util-components/scrim-card.tsx
import React23 from "react";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
// src/components/hero-banner/views/util-components/card-content.tsx
import React22 from "react";
import { UitkButtonSize as UitkButtonSize2, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var CardContent = function(param) {
    var description = param.description, primaryButtonText = param.primaryButtonText, onClickButton = param.onClickButton, onClickUrl = param.onClickUrl, disabled = param.disabled, disclaimerText = param.disclaimerText, header = param.header, _param_verticallyCenter = param.verticallyCenter, verticallyCenter = _param_verticallyCenter === void 0 ? false : _param_verticallyCenter, _param_textFullWidth = param.textFullWidth, textFullWidth = _param_textFullWidth === void 0 ? false : _param_textFullWidth;
    var layoutType = verticallyCenter ? "absolute" : "relative";
    var justifyContent = verticallyCenter ? "center" : "end";
    var topPosition = verticallyCenter ? "center" : "zero";
    var cols = verticallyCenter ? 3 : 1;
    var textCols = textFullWidth ? cols : 1;
    return /* @__PURE__ */ React22.createElement(UitkSpacing6, {
        padding: {
            inline: verticallyCenter ? "twelve" : "six"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutPosition, {
        type: layoutType,
        position: {
            top: topPosition
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex3, {
        direction: "column",
        justifyContent: justifyContent
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(UitkLayoutGrid, {
        columns: cols
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGridItem, {
        colSpan: textCols
    }, /* @__PURE__ */ React22.createElement("div", null, header))), description && /* @__PURE__ */ React22.createElement(UitkSpacing6, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGrid, {
        columns: cols
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGridItem, {
        colSpan: textCols
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(EGDSSpannableText, {
        data: description,
        textSize: 400
    }))))))), /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, primaryButtonText && /* @__PURE__ */ React22.createElement(UitkSpacing6, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLink2, {
        onClick: onClickButton
    }, /* @__PURE__ */ React22.createElement("a", {
        href: onClickUrl
    }, /* @__PURE__ */ React22.createElement(UitkSpacing6, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React22.createElement(UitkPrimaryButton2, {
        size: UitkButtonSize2.LARGE,
        disabled: disabled
    }, primaryButtonText)))))), disclaimerText && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement(UitkText3, {
        inline: "small",
        size: 100
    }, disclaimerText)))));
};
// src/components/hero-banner/views/util-components/scrim-card.tsx
var ScrimCard = function(cardContentProps) {
    var overlayType = cardContentProps.verticallyCenter ? UitkScrimType.OVERLAY : UitkScrimType.BOTTOM;
    var header = cardContentProps.header, description = cardContentProps.description, primaryButtonText = cardContentProps.primaryButtonText, disclaimerText = cardContentProps.disclaimerText;
    if (header || description || primaryButtonText || disclaimerText) {
        return /* @__PURE__ */ React23.createElement(UitkScrim, {
            type: overlayType,
            "data-stid": "overlay"
        }, /* @__PURE__ */ React23.createElement(CardContent, _object_spread({}, cardContentProps)));
    }
    return /* @__PURE__ */ React23.createElement(CardContent, _object_spread({}, cardContentProps));
};
// src/components/hero-banner/views/default-hero-banner.tsx
var DefaultHeroBanner = function(props) {
    var media = props.media, headerText = props.headerText, primaryButtonText = props.primaryButtonText, clickButtonHandler = props.clickButtonHandler, buttonLink = props.buttonLink, linkTarget = props.linkTarget, buttonDisabled = props.buttonDisabled, disclaimerText = props.disclaimerText, description = props.description;
    var scrimCardHeader = headerText ? /* @__PURE__ */ React24.createElement(UitkHeading4, {
        tag: "h2",
        size: 2
    }, headerText) : void 0;
    var scrimCardProps = {
        primaryButtonText: primaryButtonText,
        onClickButton: clickButtonHandler,
        onClickUrl: buttonLink || "",
        linkTarget: linkTarget,
        buttonDisabled: buttonDisabled,
        disclaimerText: disclaimerText,
        header: scrimCardHeader,
        description: description
    };
    return /* @__PURE__ */ React24.createElement(Viewport, null, /* @__PURE__ */ React24.createElement(ViewLarge, null, /* @__PURE__ */ React24.createElement(UitkCard4, null, /* @__PURE__ */ React24.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React24.createElement(EMImage, {
        data: media,
        aspectRatio: "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ,
        imageSize: "XL" /* XL */ ,
        placeholderImage: true
    }), /* @__PURE__ */ React24.createElement(ScrimCard, _object_spread_props(_object_spread({}, scrimCardProps), {
        verticallyCenter: true
    }))))), /* @__PURE__ */ React24.createElement(ViewMedium, null, /* @__PURE__ */ React24.createElement(UitkCard4, null, /* @__PURE__ */ React24.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React24.createElement(EMImage, {
        data: media,
        aspectRatio: "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ,
        imageSize: "XL" /* XL */ ,
        placeholderImage: true
    }), /* @__PURE__ */ React24.createElement(ScrimCard, _object_spread_props(_object_spread({}, scrimCardProps), {
        verticallyCenter: true,
        textFullWidth: true
    }))))), /* @__PURE__ */ React24.createElement(ViewSmall, null, /* @__PURE__ */ React24.createElement(UitkCard4, null, /* @__PURE__ */ React24.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React24.createElement(UitkSpacing7, {
        margin: {
            inline: "three"
        }
    }, /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(EMImage, {
        data: media,
        aspectRatio: "THREE_FOUR" /* THREE_FOUR */ ,
        imageSize: "M" /* M */ ,
        placeholderImage: true
    }), /* @__PURE__ */ React24.createElement(ScrimCard, _object_spread_props(_object_spread({}, scrimCardProps), {
        header: headerText ? /* @__PURE__ */ React24.createElement(UitkSubheading2, {
            tag: "h2"
        }, headerText) : void 0
    }))))))));
};
DefaultHeroBanner.displayName = "DefaultHeroBanner";
// src/components/hero-banner/views/high-prominence-hero-banner.tsx
import React25 from "react";
import { EGDSTeamPatternFeatureCardImageProminenceHigh } from "@egds/react-one-design-language";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var HighProminenceHeroBanner = function(props) {
    var media = props.media, _props_primaryButtonText = props.primaryButtonText, primaryButtonText = _props_primaryButtonText === void 0 ? "" : _props_primaryButtonText, _props_buttonLink = props.buttonLink, buttonLink = _props_buttonLink === void 0 ? "" : _props_buttonLink, _props_headerText = props.headerText, headerText = _props_headerText === void 0 ? "" : _props_headerText, _props_subHeaderText = props.subHeaderText, subHeaderText = _props_subHeaderText === void 0 ? "" : _props_subHeaderText, description = props.description, clickButtonHandler = props.clickButtonHandler;
    var bannerDescription = description ? /* @__PURE__ */ React25.createElement(EGDSSpannableText, {
        data: description,
        textSize: 400,
        theme: "light"
    }) : "";
    var _imageSelector;
    var mediumImage = (_imageSelector = imageSelector(media.sourceSet, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , "XL" /* XL */ )) !== null && _imageSelector !== void 0 ? _imageSelector : "";
    var _imageSelector1;
    var smallImage = (_imageSelector1 = imageSelector(media.sourceSet, "THREE_FOUR" /* THREE_FOUR */ , "M" /* M */ )) !== null && _imageSelector1 !== void 0 ? _imageSelector1 : "";
    var featureBanner = function(imageSrc) {
        return /* @__PURE__ */ React25.createElement(EGDSTeamPatternFeatureCardImageProminenceHigh, {
            patternImgSrcMedLarge: imageSrc,
            patternImgSrcSmall: imageSrc,
            patternImgAltText: media.description,
            patternButtonText: primaryButtonText,
            patternButtonLink: buttonLink,
            patternTextHeading: headerText,
            patternTextSubheading: bannerDescription,
            patternHeadingSizeMedLarge: 3,
            patternHeadingSizeSmall: 4,
            patternBadgeText: subHeaderText,
            buttonOnClick: clickButtonHandler
        });
    };
    return /* @__PURE__ */ React25.createElement(Viewport2, null, /* @__PURE__ */ React25.createElement(ViewSmall2, null, featureBanner(smallImage)), /* @__PURE__ */ React25.createElement(ViewMedium2, null, featureBanner(mediumImage)));
};
HighProminenceHeroBanner.displayName = "HighProminenceHeroBanner";
// src/components/hero-banner/views/low-prominence-leading-hero-banner.tsx
import React26 from "react";
import { EGDSTeamPatternFeatureCardImageProminenceLow } from "@egds/react-one-design-language";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var LowProminenceLeadingHeroBanner = function(props) {
    var media = props.media, _props_primaryButtonText = props.primaryButtonText, primaryButtonText = _props_primaryButtonText === void 0 ? "" : _props_primaryButtonText, _props_buttonLink = props.buttonLink, buttonLink = _props_buttonLink === void 0 ? "" : _props_buttonLink, _props_headerText = props.headerText, headerText = _props_headerText === void 0 ? "" : _props_headerText, _props_subHeaderText = props.subHeaderText, subHeaderText = _props_subHeaderText === void 0 ? "" : _props_subHeaderText, description = props.description, clickButtonHandler = props.clickButtonHandler;
    var bannerDescription = description ? /* @__PURE__ */ React26.createElement(EGDSSpannableText, {
        data: description,
        textSize: 400
    }) : "";
    var _imageSelector;
    var mediumImage = (_imageSelector = imageSelector(media.sourceSet, "THREE_TWO" /* THREE_TWO */ , "XL" /* XL */ )) !== null && _imageSelector !== void 0 ? _imageSelector : "";
    var _imageSelector1;
    var smallImage = (_imageSelector1 = imageSelector(media.sourceSet, "THREE_TWO" /* THREE_TWO */ , "M" /* M */ )) !== null && _imageSelector1 !== void 0 ? _imageSelector1 : "";
    var featureBanner = function(imageSrc) {
        return /* @__PURE__ */ React26.createElement(EGDSTeamPatternFeatureCardImageProminenceLow, {
            imageConfiguration: "leading",
            patternImgSrc: imageSrc,
            patternImgAltText: media.description,
            patternButtonText: primaryButtonText,
            patternButtonLink: buttonLink,
            patternTextHeading: headerText,
            patternTextSubheading: bannerDescription,
            patternHeadingSizeMedLarge: 3,
            patternHeadingSizeSmall: 4,
            patternBadgeText: subHeaderText,
            buttonOnClick: clickButtonHandler
        });
    };
    return /* @__PURE__ */ React26.createElement(Viewport3, null, /* @__PURE__ */ React26.createElement(ViewSmall3, null, featureBanner(smallImage)), /* @__PURE__ */ React26.createElement(ViewMedium3, null, featureBanner(mediumImage)));
};
LowProminenceLeadingHeroBanner.displayName = "LowProminenceLeadingHeroBanner";
// src/components/hero-banner/views/low-prominence-trailing-hero-banner.tsx
import React27 from "react";
import { EGDSTeamPatternFeatureCardImageProminenceLow as EGDSTeamPatternFeatureCardImageProminenceLow2 } from "@egds/react-one-design-language";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var LowProminenceTrailingHeroBanner = function(props) {
    var media = props.media, _props_primaryButtonText = props.primaryButtonText, primaryButtonText = _props_primaryButtonText === void 0 ? "" : _props_primaryButtonText, _props_buttonLink = props.buttonLink, buttonLink = _props_buttonLink === void 0 ? "" : _props_buttonLink, _props_headerText = props.headerText, headerText = _props_headerText === void 0 ? "" : _props_headerText, _props_subHeaderText = props.subHeaderText, subHeaderText = _props_subHeaderText === void 0 ? "" : _props_subHeaderText, description = props.description, clickButtonHandler = props.clickButtonHandler;
    var bannerDescription = description ? /* @__PURE__ */ React27.createElement(EGDSSpannableText, {
        data: description,
        textSize: 400
    }) : "";
    var _imageSelector;
    var mediumImage = (_imageSelector = imageSelector(media.sourceSet, "THREE_TWO" /* THREE_TWO */ , "XL" /* XL */ )) !== null && _imageSelector !== void 0 ? _imageSelector : "";
    var _imageSelector1;
    var smallImage = (_imageSelector1 = imageSelector(media.sourceSet, "THREE_TWO" /* THREE_TWO */ , "M" /* M */ )) !== null && _imageSelector1 !== void 0 ? _imageSelector1 : "";
    var featureBanner = function(imageSrc) {
        return /* @__PURE__ */ React27.createElement(EGDSTeamPatternFeatureCardImageProminenceLow2, {
            imageConfiguration: "trailing",
            patternImgSrc: imageSrc,
            patternImgAltText: media.description,
            patternButtonText: primaryButtonText,
            patternButtonLink: buttonLink,
            patternTextHeading: headerText,
            patternTextSubheading: bannerDescription,
            patternHeadingSizeMedLarge: 3,
            patternHeadingSizeSmall: 4,
            patternBadgeText: subHeaderText,
            buttonOnClick: clickButtonHandler
        });
    };
    return /* @__PURE__ */ React27.createElement(Viewport4, null, /* @__PURE__ */ React27.createElement(ViewSmall4, null, featureBanner(smallImage)), /* @__PURE__ */ React27.createElement(ViewMedium4, null, featureBanner(mediumImage)));
};
LowProminenceTrailingHeroBanner.displayName = "LowProminenceTrailingHeroBanner";
// src/components/hero-banner/views/medium-prominence-hero-banner.tsx
import React28 from "react";
import { EGDSTeamPatternFeatureCardImageProminenceMid } from "@egds/react-one-design-language";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
var MediumProminenceHeroBanner = function(props) {
    var media = props.media, _props_primaryButtonText = props.primaryButtonText, primaryButtonText = _props_primaryButtonText === void 0 ? "" : _props_primaryButtonText, _props_buttonLink = props.buttonLink, buttonLink = _props_buttonLink === void 0 ? "" : _props_buttonLink, _props_headerText = props.headerText, headerText = _props_headerText === void 0 ? "" : _props_headerText, _props_subHeaderText = props.subHeaderText, subHeaderText = _props_subHeaderText === void 0 ? "" : _props_subHeaderText, description = props.description, clickButtonHandler = props.clickButtonHandler;
    var bannerDescription = description ? /* @__PURE__ */ React28.createElement(EGDSSpannableText, {
        data: description,
        textSize: 400
    }) : "";
    var _imageSelector;
    var mediumImage = (_imageSelector = imageSelector(media.sourceSet, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , "XL" /* XL */ )) !== null && _imageSelector !== void 0 ? _imageSelector : "";
    var _imageSelector1;
    var smallImage = (_imageSelector1 = imageSelector(media.sourceSet, "THREE_FOUR" /* THREE_FOUR */ , "M" /* M */ )) !== null && _imageSelector1 !== void 0 ? _imageSelector1 : "";
    var featureBanner = function(imageSrc) {
        return /* @__PURE__ */ React28.createElement(EGDSTeamPatternFeatureCardImageProminenceMid, {
            patternImgSrcMedLarge: imageSrc,
            patternImgSrcSmall: imageSrc,
            patternImgAltText: media.description,
            patternButtonText: primaryButtonText,
            patternButtonLink: buttonLink,
            patternTextHeading: headerText,
            patternTextSubheading: bannerDescription,
            patternHeadingSizeMedLarge: 3,
            patternHeadingSizeSmall: 4,
            patternBadgeText: subHeaderText,
            buttonOnClick: clickButtonHandler
        });
    };
    return /* @__PURE__ */ React28.createElement(Viewport5, null, /* @__PURE__ */ React28.createElement(ViewSmall5, null, featureBanner(smallImage)), /* @__PURE__ */ React28.createElement(ViewMedium5, null, featureBanner(mediumImage)));
};
MediumProminenceHeroBanner.displayName = "MediumProminenceHeroBanner";
// src/components/hero-banner/hero-banner-views.ts
var HeroBannerViews = /* @__PURE__ */ function(HeroBannerViews2) {
    HeroBannerViews2["Default"] = "default";
    HeroBannerViews2["LowProminenceTrailing"] = "lowProminenceTrailing";
    HeroBannerViews2["LowProminenceLeading"] = "lowProminenceLeading";
    HeroBannerViews2["MediumProminence"] = "mediumProminence";
    HeroBannerViews2["HighProminence"] = "highProminence";
    return HeroBannerViews2;
}(HeroBannerViews || {});
var _obj6;
var HeroBannerViewMap = (_obj6 = {}, _define_property(_obj6, "default" /* Default */ , DefaultHeroBanner), _define_property(_obj6, "lowProminenceTrailing" /* LowProminenceTrailing */ , LowProminenceTrailingHeroBanner), _define_property(_obj6, "lowProminenceLeading" /* LowProminenceLeading */ , LowProminenceLeadingHeroBanner), _define_property(_obj6, "mediumProminence" /* MediumProminence */ , MediumProminenceHeroBanner), _define_property(_obj6, "highProminence" /* HighProminence */ , HighProminenceHeroBanner), _obj6);
// src/components/hero-banner/hero-banner.tsx
var __Query4 = gql19(_templateObject18(), EMImage.fragment, EGDSHeading.fragment, EGDSSpannableText.fragment);
var HeroBanner = function(props) {
    var _data_travelExperienceManagerContent_editorialComponent, _items_, _description_;
    var inputs = props.inputs, skipSsr = props.skipSsr, analyticsData = props.analyticsData, _props_view = props.view, view = _props_view === void 0 ? "default" /* Default */  : _props_view;
    var context = useBexApi4().context;
    var trackClick = useClickTracker2();
    var egClickTracker = useEgClickstream3();
    var multiArmBanditTrack = useMultiArmBanditContext().multiArmBanditTrack;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__Query4, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading || error || (data === null || data === void 0 ? void 0 : (_data_travelExperienceManagerContent_editorialComponent = data.travelExperienceManagerContent.editorialComponent) === null || _data_travelExperienceManagerContent_editorialComponent === void 0 ? void 0 : _data_travelExperienceManagerContent_editorialComponent.content.__typename) !== "EMRichTextMediaActions" || !data.travelExperienceManagerContent.editorialComponent.content.mediaAssets || !data.travelExperienceManagerContent.editorialComponent.content.textComponents) {
        return null;
    }
    var HeroBannerComponent = HeroBannerViewMap[view];
    if (!HeroBannerComponent) {
        return null;
    }
    var _data_travelExperienceManagerContent_editorialComponent_content = data.travelExperienceManagerContent.editorialComponent.content, clickActions = _data_travelExperienceManagerContent_editorialComponent_content.clickActions, textComponents = _data_travelExperienceManagerContent_editorialComponent_content.textComponents, mediaAssets = _data_travelExperienceManagerContent_editorialComponent_content.mediaAssets, contentMetadata = _data_travelExperienceManagerContent_editorialComponent_content.contentMetadata;
    var items = mediaAssets.items;
    if (!items || ((_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.media.__typename) !== "EMImage" || Array.isArray(clickActions) && clickActions[0] && clickActions[0].clickActionType.__typename !== "UIPrimaryButton") {
        return null;
    }
    var header = textComponents.header, subHeader = textComponents.subHeader, description = textComponents.description;
    var defaultClickAction = {
        action: null,
        clickActionType: {
            disabled: false,
            primary: null
        },
        description: null
    };
    var clickAction = Array.isArray(clickActions) && clickActions[0] || defaultClickAction;
    var action = clickAction.action, clickActionType = clickAction.clickActionType;
    var disclaimerText = clickAction.description ? clickAction.description : void 0;
    var _ref = action || {}, _ref_resource = _ref.resource, resource = _ref_resource === void 0 ? null : _ref_resource, _ref_analytics = _ref.analytics, analytics = _ref_analytics === void 0 ? null : _ref_analytics;
    var disabled = clickActionType.disabled, primary = clickActionType.primary;
    var contentAnalyticsData = analyticsData ? createContentDataPayload(JSON.parse(analyticsData), contentMetadata === null || contentMetadata === void 0 ? void 0 : contentMetadata.contentId) : null;
    if (contentAnalyticsData) {
        var defaultImpressionData = _object_spread({
            event: event_hero_presented
        }, contentAnalyticsData);
        egClickTracker(defaultImpressionData);
    }
    var onClickButton = function() {
        if (!analytics) {
            return;
        }
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        trackClick(referrerId, linkName);
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (contentAnalyticsData) {
            var clickImpressionData = _object_spread({
                event: event_hero_selected
            }, contentAnalyticsData);
            egClickTracker(clickImpressionData);
        }
    };
    var media = items[0].media;
    var heroBannerProps = {
        media: media,
        headerText: header === null || header === void 0 ? void 0 : header.text,
        subHeaderText: subHeader === null || subHeader === void 0 ? void 0 : subHeader.text,
        primaryButtonText: primary,
        clickButtonHandler: onClickButton,
        buttonLink: resource === null || resource === void 0 ? void 0 : resource.value,
        buttonDisabled: disabled,
        disclaimerText: disclaimerText,
        description: description && ((_description_ = description[0]) === null || _description_ === void 0 ? void 0 : _description_.__typename) === "EGDSSpannableText" ? description[0] : void 0
    };
    return /* @__PURE__ */ React29.createElement(HeroBannerComponent, _object_spread({}, heroBannerProps));
};
HeroBanner.displayName = "sharedui-HeroBanner";
// src/components/text/text.tsx
import React39 from "react";
import { gql as gql22, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// src/components/text/__private/__fragments/rich-text-component.tsx
import React30 from "react";
import { gql as gql20 } from "@apollo/client";
import { RichText as EGDSRichText, slateToMdastPreprocessor } from "@egds/react-content-management";
var fragment16 = gql20(_templateObject19());
var placeholderProcessor = {
    condition: function(param) {
        var type = param.type;
        return type === "placeholder";
    },
    converter: function(param) {
        var value = param.value, children = param.children;
        var result = {
            type: "text",
            value: value,
            children: []
        };
        var _ref = children.length && children[0], bold = _ref.bold, italic = _ref.italic, underline = _ref.underline, subscript = _ref.subscript, superscript = _ref.superscript;
        if (bold) {
            result = {
                type: "strong",
                children: [
                    result
                ]
            };
        }
        if (italic) {
            result = {
                type: "emphasis",
                children: [
                    result
                ]
            };
        }
        if (underline) {
            result = {
                type: "underline",
                children: [
                    result
                ]
            };
        }
        if (subscript) {
            result = {
                type: "subscript",
                children: [
                    result
                ]
            };
        }
        if (superscript) {
            result = {
                type: "superscript",
                children: [
                    result
                ]
            };
        }
        return result;
    }
};
var preprocessors = [
    placeholderProcessor
].concat(_to_consumable_array(slateToMdastPreprocessor));
var RichText = function(param) {
    var data = param.data;
    if (!data.value) {
        return null;
    }
    return /* @__PURE__ */ React30.createElement(EGDSRichText, {
        data: JSON.parse(data.value),
        preprocessors: preprocessors
    });
};
RichText.fragment = fragment16;
RichText.displayName = "RichTextFragment";
// src/components/text/__private/__fragments/text-click-actions.tsx
import React31 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
var fragment17 = gql21(_templateObject20());
var TextClickActions = function(props) {
    var _data_action_resource, _data_action;
    var data = props.data;
    if (!((_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_resource = _data_action.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value)) {
        return null;
    }
    return /* @__PURE__ */ React31.createElement(UitkCardLink2, null, /* @__PURE__ */ React31.createElement("a", {
        href: data.action.resource.value,
        target: data.action.target
    }, data.action.accessibility));
};
TextClickActions.fragment = fragment17;
TextClickActions.displayName = "TextClickActions";
// src/components/text/event-config.ts
var event_text_presented = {
    event_name: "content_text_block.presented",
    event_type: "Impression",
    event_version: "1.2.0",
    event_category: "Landing"
};
// src/components/text/views/centered-card-view.tsx
import React33 from "react";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkLayoutColumns } from "uitk-react-layout-columns";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText4 } from "uitk-react-text";
// src/components/text/__private/description-element.tsx
import React32 from "react";
import { ViewLarge as ViewLarge2, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var DescriptionElement = function(param) {
    var block = param.block, index = param.index;
    switch(block.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React32.createElement(EGDSHeading, {
                data: block,
                key: index
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React32.createElement(EGDSSpannableText, {
                data: block,
                key: index,
                textSize: 300,
                linkSize: "medium"
            });
        case "RichText":
            return /* @__PURE__ */ React32.createElement(RichText, {
                data: block
            });
        default:
            return null;
    }
};
var InformationDescriptionElement = function(param) {
    var block = param.block, index = param.index;
    switch(block.__typename){
        case "EGDSSpannableText":
            return /* @__PURE__ */ React32.createElement(Viewport6, null, /* @__PURE__ */ React32.createElement(ViewLarge2, null, /* @__PURE__ */ React32.createElement(EGDSSpannableText, {
                data: block,
                key: index,
                textSize: 400,
                linkSize: "medium",
                theme: "inverse"
            })), /* @__PURE__ */ React32.createElement(ViewSmall6, null, /* @__PURE__ */ React32.createElement(EGDSSpannableText, {
                data: block,
                key: index,
                textSize: 300,
                linkSize: "medium",
                theme: "inverse"
            })));
        default:
            return null;
    }
};
// src/components/text/views/centered-card-view.tsx
var Header = function(param) {
    var header = param.header;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React33.createElement(UitkHeading5, {
        tag: "h2",
        size: 2,
        align: "center"
    }, header.text);
};
var SubHeader = function(param) {
    var subHeader = param.subHeader;
    if (!(subHeader === null || subHeader === void 0 ? void 0 : subHeader.text)) {
        return null;
    }
    return /* @__PURE__ */ React33.createElement(UitkHeading5, {
        tag: "h3",
        size: 4,
        align: "center"
    }, subHeader.text);
};
var Description2 = function(param) {
    var description = param.description;
    if (!description || description.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React33.createElement(UitkLayoutColumns, {
        columns: 1,
        space: "six",
        "data-stid": "columns-1"
    }, description.map(function(block, index) {
        return /* @__PURE__ */ React33.createElement(UitkSpacing8, {
            padding: {
                blockstart: block.__typename === "RichText" ? "unset" : "two"
            },
            key: index
        }, /* @__PURE__ */ React33.createElement("div", null, /* @__PURE__ */ React33.createElement(UitkText4, {
            align: "center"
        }, /* @__PURE__ */ React33.createElement(DescriptionElement, {
            block: block,
            index: index
        }))));
    }));
};
var CenteredCardView = function(param) {
    var content = param.content, clickActions = param.clickActions;
    return /* @__PURE__ */ React33.createElement(UitkCard5, {
        border: true
    }, /* @__PURE__ */ React33.createElement(UitkCardContentSection4, {
        padded: true
    }, /* @__PURE__ */ React33.createElement(Header, {
        header: content.header
    }), /* @__PURE__ */ React33.createElement(SubHeader, {
        subHeader: content.subHeader
    }), /* @__PURE__ */ React33.createElement(Description2, {
        description: content.description
    })), clickActions && clickActions.length > 0 && /* @__PURE__ */ React33.createElement(TextClickActions, {
        data: clickActions[0]
    }));
};
// src/components/text/views/header-view.tsx
import React34 from "react";
import { UitkHeading as UitkHeading6, UitkParagraph as UitkParagraph2 } from "uitk-react-text";
var Header2 = function(param) {
    var header = param.header;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React34.createElement(UitkHeading6, {
        tag: "h1",
        size: 1
    }, header.text);
};
var SubHeader2 = function(param) {
    var subHeader = param.subHeader;
    if (!(subHeader === null || subHeader === void 0 ? void 0 : subHeader.text)) {
        return null;
    }
    return /* @__PURE__ */ React34.createElement(UitkParagraph2, {
        size: 1
    }, subHeader.text);
};
var HeaderView = function(param) {
    var content = param.content;
    return /* @__PURE__ */ React34.createElement("div", null, /* @__PURE__ */ React34.createElement(Header2, {
        header: content.header
    }), /* @__PURE__ */ React34.createElement(SubHeader2, {
        subHeader: content.subHeader
    }));
};
// src/components/text/views/info-banner-view.tsx
import React35 from "react";
import { UitkBanner } from "uitk-react-banner";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutColumns as UitkLayoutColumns2 } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
var Description3 = function(param) {
    var description = param.description;
    if (description.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React35.createElement(UitkLayoutColumns2, {
        columns: 1,
        space: "six",
        "data-stid": "columns-".concat(1)
    }, description.map(function(block, index) {
        return /* @__PURE__ */ React35.createElement(UitkSpacing9, {
            padding: {
                blockstart: block.__typename === "RichText" ? "unset" : "two"
            },
            key: index
        }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkText5, {
            align: "center"
        }, /* @__PURE__ */ React35.createElement(InformationDescriptionElement, {
            block: block,
            index: index
        }))));
    }));
};
var InformationBannerView = function(param) {
    var content = param.content;
    return /* @__PURE__ */ React35.createElement(UitkBanner, {
        theme: "critical"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlex4, {
        alignItems: "center",
        space: "six"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlex4, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, {
        alignSelf: "start",
        grow: 0,
        shrink: 0
    }, /* @__PURE__ */ React35.createElement(UitkSpacing9, {
        margin: {
            block: "one",
            inline: "one"
        },
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkIcon, {
        name: "info",
        title: "information-message-icon",
        description: "information-message-icon",
        theme: "inverse",
        size: UitkIconSize.MEDIUM
    })))))), /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(UitkSpacing9, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlex4, {
        direction: "column",
        alignItems: "start",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, content.header && /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(UitkSpacing9, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkText5, {
        theme: "inverse",
        align: "left",
        size: 400,
        weight: "bold"
    }, content.header.text)))), content.subHeader && /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(UitkSpacing9, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkText5, {
        theme: "inverse",
        align: "left",
        size: 300,
        weight: "regular"
    }, content.subHeader.text)))), content.description && /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(Description3, {
        description: content.description
    })))))));
};
// src/components/text/views/one-view.tsx
import React36 from "react";
import { UitkLayoutColumns as UitkLayoutColumns3 } from "uitk-react-layout-columns";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkParagraph as UitkParagraph3 } from "uitk-react-text";
var Header3 = function(param) {
    var header = param.header;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React36.createElement(UitkHeading7, {
        tag: "h2",
        size: 3
    }, header.text);
};
var SubHeader3 = function(param) {
    var subHeader = param.subHeader;
    if (!(subHeader === null || subHeader === void 0 ? void 0 : subHeader.text)) {
        return null;
    }
    return /* @__PURE__ */ React36.createElement(UitkParagraph3, {
        size: 2
    }, subHeader.text);
};
var Description4 = function(param) {
    var description = param.description;
    if (!description || description.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React36.createElement(UitkLayoutColumns3, {
        columns: 1,
        space: "six",
        "data-stid": "columns-1"
    }, description.map(function(block, index) {
        return /* @__PURE__ */ React36.createElement(UitkSpacing10, {
            padding: {
                blockstart: block.__typename === "RichText" ? "unset" : "two"
            },
            key: index
        }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(DescriptionElement, {
            block: block,
            index: index
        })));
    }));
};
var OneView = function(param) {
    var content = param.content;
    return /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(Header3, {
        header: content.header
    }), /* @__PURE__ */ React36.createElement(SubHeader3, {
        subHeader: content.subHeader
    }), /* @__PURE__ */ React36.createElement(UitkSpacing10, {
        padding: content.header || content.subHeader ? {
            blockstart: "three"
        } : "unset"
    }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(Description4, {
        description: content.description
    }))));
};
// src/components/text/views/sub-header-view.tsx
import React37 from "react";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
var SubHeaderView = function(param) {
    var content = param.content;
    var _content_subHeader;
    if (!((_content_subHeader = content.subHeader) === null || _content_subHeader === void 0 ? void 0 : _content_subHeader.text)) {
        return null;
    }
    return /* @__PURE__ */ React37.createElement(UitkHeading8, {
        tag: "h2",
        size: 3
    }, content.subHeader.text);
};
// src/components/text/views/two-view.tsx
import React38 from "react";
import { ViewLarge as ViewLarge3, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkLayoutColumns as UitkLayoutColumns4 } from "uitk-react-layout-columns";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkParagraph as UitkParagraph4 } from "uitk-react-text";
var Header4 = function(param) {
    var header = param.header;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React38.createElement(UitkHeading9, {
        tag: "h2",
        size: 3
    }, header.text);
};
var SubHeader4 = function(param) {
    var subHeader = param.subHeader;
    if (!(subHeader === null || subHeader === void 0 ? void 0 : subHeader.text)) {
        return null;
    }
    return /* @__PURE__ */ React38.createElement(UitkParagraph4, {
        size: 2
    }, subHeader.text);
};
var Description5 = function(param) {
    var description = param.description, columns = param.columns;
    if (!description || description.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React38.createElement(UitkLayoutColumns4, {
        columns: columns,
        space: "six",
        "data-stid": "columns-".concat(columns)
    }, description.map(function(block, index) {
        return /* @__PURE__ */ React38.createElement(UitkSpacing11, {
            padding: {
                blockstart: block.__typename === "RichText" ? "unset" : "two"
            },
            key: index
        }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(DescriptionElement, {
            block: block,
            index: index
        })));
    }));
};
var TwoView = function(param) {
    var content = param.content;
    return /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(Header4, {
        header: content.header
    }), /* @__PURE__ */ React38.createElement(SubHeader4, {
        subHeader: content.subHeader
    }), /* @__PURE__ */ React38.createElement(UitkSpacing11, {
        padding: content.header || content.subHeader ? {
            blockstart: "three"
        } : "unset"
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(Viewport7, null, /* @__PURE__ */ React38.createElement(ViewLarge3, null, /* @__PURE__ */ React38.createElement(Description5, {
        description: content.description,
        columns: 2
    })), /* @__PURE__ */ React38.createElement(ViewSmall7, null, /* @__PURE__ */ React38.createElement(Description5, {
        description: content.description,
        columns: 1
    }))))));
};
// src/components/text/views/index.ts
var TextViewComponentMap = {
    header: HeaderView,
    "sub-header": SubHeaderView,
    one: OneView,
    two: TwoView,
    "centered-card": CenteredCardView,
    information: InformationBannerView
};
// src/components/text/text.tsx
var __Query5 = gql22(_templateObject21(), EGDSHeading.fragment, EGDSSpannableText.fragment, RichText.fragment, TextClickActions.fragment);
var Text = function(props) {
    var _data_travelExperienceManagerContent_editorialComponent;
    var inputs = props.inputs, skipSsr = props.skipSsr, analyticsData = props.analyticsData;
    var context = useBexApi5().context;
    var trackClick = useEgClickstream4();
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__Query5, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    if (loading || error || (data === null || data === void 0 ? void 0 : (_data_travelExperienceManagerContent_editorialComponent = data.travelExperienceManagerContent.editorialComponent) === null || _data_travelExperienceManagerContent_editorialComponent === void 0 ? void 0 : _data_travelExperienceManagerContent_editorialComponent.content.__typename) !== "EMRichTextMediaActions" || !data.travelExperienceManagerContent.editorialComponent.content.textComponents) {
        return null;
    }
    var _data_travelExperienceManagerContent_editorialComponent_content = data.travelExperienceManagerContent.editorialComponent.content, textComponents = _data_travelExperienceManagerContent_editorialComponent_content.textComponents, contentMetadata = _data_travelExperienceManagerContent_editorialComponent_content.contentMetadata, clickActions = _data_travelExperienceManagerContent_editorialComponent_content.clickActions;
    var header = textComponents.header, subHeader = textComponents.subHeader, description = textComponents.description;
    var view = props.view;
    var TextComponent = TextViewComponentMap[view];
    if (analyticsData) {
        var contentAnalyticsData = createContentDataPayload(JSON.parse(analyticsData), contentMetadata === null || contentMetadata === void 0 ? void 0 : contentMetadata.contentId);
        var defaultImpressionData = _object_spread({
            event: event_text_presented
        }, contentAnalyticsData);
        trackClick(defaultImpressionData);
    }
    var textComponentProps = {
        // Generated types are incomplete, this is the correct type
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        clickActions: clickActions,
        content: {
            header: header,
            subHeader: subHeader,
            description: description
        }
    };
    return /* @__PURE__ */ React39.createElement(TextComponent, _object_spread({}, textComponentProps));
};
Text.displayName = "sharedui-Text";
// src/components/image/image.tsx
import React44 from "react";
import { gql as gql23, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
// src/components/image/image-views.ts
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
// src/components/image/hoc/with-ratio.ts
var withRatio = function(component, aspectRatio) {
    return function(props) {
        return component(_object_spread_props(_object_spread({}, props), {
            ratio: aspectRatio
        }));
    };
};
// src/components/image/views/aspect-ratio-image.tsx
import React40 from "react";
import { UitkFigure as UitkFigure5, UitkImage as UitkImage4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
var AspectRatioImage = function(props) {
    var ratio = props.ratio, media = props.media;
    return /* @__PURE__ */ React40.createElement(UitkLayoutFlex5, {
        justifyContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem4, {
        grow: 1,
        alignSelf: "center"
    }, /* @__PURE__ */ React40.createElement(UitkFigure5, {
        ratio: ratio
    }, /* @__PURE__ */ React40.createElement(UitkImage4, {
        placeholderImage: true,
        alt: media.description,
        src: media.url
    }))));
};
// src/components/image/views/full-width-image.tsx
import React41 from "react";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium6, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
var FullWidthImage = function(props) {
    var media = props.media;
    return /* @__PURE__ */ React41.createElement(Viewport8, null, /* @__PURE__ */ React41.createElement(ViewLarge4, null, /* @__PURE__ */ React41.createElement(EMImage, {
        data: _object_spread({}, media),
        aspectRatio: "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ,
        imageSize: "XL" /* XL */ ,
        placeholderImage: true
    })), /* @__PURE__ */ React41.createElement(ViewMedium6, null, /* @__PURE__ */ React41.createElement(EMImage, {
        data: _object_spread({}, media),
        aspectRatio: "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ,
        imageSize: "XL" /* XL */ ,
        placeholderImage: true
    })), /* @__PURE__ */ React41.createElement(ViewSmall8, null, /* @__PURE__ */ React41.createElement(EMImage, {
        data: _object_spread({}, media),
        aspectRatio: "THREE_FOUR" /* THREE_FOUR */ ,
        imageSize: "M" /* M */ ,
        placeholderImage: true
    })));
};
// src/components/image/views/logo-with-bottom-caption-image.tsx
import React42 from "react";
import { UitkFigure as UitkFigure6, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkText as UitkText6 } from "uitk-react-text";
var LogoWithBottomCaptionImage = function(props) {
    var media = props.media, description = props.description;
    var imageCaption = description ? /* @__PURE__ */ React42.createElement(EGDSSpannableText, {
        align: "center",
        data: description
    }) : null;
    return /* @__PURE__ */ React42.createElement(UitkLayoutFlex6, {
        justifyContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem5, {
        maxWidth: 300,
        grow: 1,
        alignSelf: "center"
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(UitkFigure6, {
        imageFit: "contain"
    }, /* @__PURE__ */ React42.createElement(UitkImage5, {
        placeholderImage: true,
        blankDefault: true,
        alt: media.description,
        src: media.url
    })), imageCaption && /* @__PURE__ */ React42.createElement(UitkText6, {
        align: "center"
    }, imageCaption))));
};
// src/components/image/views/logo-with-top-caption-image.tsx
import React43 from "react";
import { UitkFigure as UitkFigure7, UitkImage as UitkImage6 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkText as UitkText7 } from "uitk-react-text";
var LogoWithTopCaptionImage = function(props) {
    var media = props.media, description = props.description;
    var imageCaption = description ? /* @__PURE__ */ React43.createElement(EGDSSpannableText, {
        align: "center",
        data: description
    }) : null;
    return /* @__PURE__ */ React43.createElement(UitkLayoutFlex7, {
        justifyContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem6, {
        maxWidth: 300,
        grow: 1,
        alignSelf: "center"
    }, /* @__PURE__ */ React43.createElement("div", null, imageCaption && /* @__PURE__ */ React43.createElement(UitkText7, {
        align: "center"
    }, imageCaption), /* @__PURE__ */ React43.createElement(UitkFigure7, {
        imageFit: "contain"
    }, /* @__PURE__ */ React43.createElement(UitkImage6, {
        placeholderImage: true,
        blankDefault: true,
        alt: media.description,
        src: media.url
    })))));
};
// src/components/image/image-views.ts
var ImageViews = /* @__PURE__ */ function(ImageViews2) {
    ImageViews2["FullWidth"] = "full-width";
    ImageViews2["LogoWithBottomCaption"] = "logo-bottom";
    ImageViews2["LogoWithTopCaption"] = "logo-top";
    ImageViews2["AspectRatioOneToOne"] = "aspect-ratio-1:1";
    ImageViews2["AspectRatioFourToThree"] = "aspect-ratio-4:3";
    ImageViews2["AspectRatioThreeToTwo"] = "aspect-ratio-3:2";
    ImageViews2["AspectRatioSixteenToNine"] = "aspect-ratio-16:9";
    ImageViews2["AspectRatioTwentyOneToNine"] = "aspect-ratio-21:9";
    ImageViews2["AspectRatioFourToOne"] = "aspect-ratio-4:1";
    ImageViews2["AspectRatioThreeToFour"] = "aspect-ratio-3:4";
    return ImageViews2;
}(ImageViews || {});
var _obj7;
var ImageViewMap = (_obj7 = {}, _define_property(_obj7, "full-width" /* FullWidth */ , FullWidthImage), _define_property(_obj7, "logo-top" /* LogoWithTopCaption */ , LogoWithTopCaptionImage), _define_property(_obj7, "logo-bottom" /* LogoWithBottomCaption */ , LogoWithBottomCaptionImage), _define_property(_obj7, "aspect-ratio-1:1" /* AspectRatioOneToOne */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R1_1)), _define_property(_obj7, "aspect-ratio-4:3" /* AspectRatioFourToThree */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R4_3)), _define_property(_obj7, "aspect-ratio-3:2" /* AspectRatioThreeToTwo */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R3_2)), _define_property(_obj7, "aspect-ratio-16:9" /* AspectRatioSixteenToNine */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R16_9)), _define_property(_obj7, "aspect-ratio-21:9" /* AspectRatioTwentyOneToNine */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R21_9)), _define_property(_obj7, "aspect-ratio-4:1" /* AspectRatioFourToOne */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R4_1)), _define_property(_obj7, "aspect-ratio-3:4" /* AspectRatioThreeToFour */ , withRatio(AspectRatioImage, UitkFigureAspectRatioType4.R3_4)), _obj7);
// src/components/image/image.tsx
var __Query6 = gql23(_templateObject22(), EMImage.fragment, EGDSSpannableText.fragment);
var Image2 = function(props) {
    var _data_travelExperienceManagerContent_editorialComponent, _items_, _description_;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_view = props.view, view = _props_view === void 0 ? "full-width" /* FullWidth */  : _props_view;
    var context = useBexApi6().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery6 = useQuery6(__Query6, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery6.data, error = _useQuery6.error, loading = _useQuery6.loading;
    if (loading || error || (data === null || data === void 0 ? void 0 : (_data_travelExperienceManagerContent_editorialComponent = data.travelExperienceManagerContent.editorialComponent) === null || _data_travelExperienceManagerContent_editorialComponent === void 0 ? void 0 : _data_travelExperienceManagerContent_editorialComponent.content.__typename) !== "EMRichTextMediaActions" || !data.travelExperienceManagerContent.editorialComponent.content.mediaAssets || !data.travelExperienceManagerContent.editorialComponent.content.textComponents) {
        return null;
    }
    var ImageComponent = ImageViewMap[view];
    if (!ImageComponent) {
        return null;
    }
    var _data_travelExperienceManagerContent_editorialComponent_content = data.travelExperienceManagerContent.editorialComponent.content, textComponents = _data_travelExperienceManagerContent_editorialComponent_content.textComponents, mediaAssets = _data_travelExperienceManagerContent_editorialComponent_content.mediaAssets;
    var items = mediaAssets.items;
    if (!items || ((_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.media.__typename) !== "EMImage") {
        return null;
    }
    var description = textComponents.description;
    var descriptionSpannableText = description && ((_description_ = description[0]) === null || _description_ === void 0 ? void 0 : _description_.__typename) === "EGDSSpannableText" ? description[0] : void 0;
    var media = items[0].media;
    return /* @__PURE__ */ React44.createElement(ImageComponent, {
        media: media,
        description: descriptionSpannableText
    });
};
Image2.displayName = "sharedui-Image";
export { Editorial, ExperienceCard, HeroBanner, HeroBannerViews, HeroImage, Image2 as Image, ImageViews, Text };
//# sourceMappingURL=index.js.map